import { render } from "./EditDealer.vue?vue&type=template&id=077bfb59"
import script from "./EditDealer.vue?vue&type=script&lang=js"
export * from "./EditDealer.vue?vue&type=script&lang=js"

import exportComponent from "/srv/strapi/LessMessAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__